import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/format-message';
import { Link } from '@instructure/ui-link';

// Component exists to prevent the recreation of the scroll function with each render,
// which would cause a new rerender on each data change
export var Pin = /*#__PURE__*/function (_Component) {
  function Pin() {
    var _this2;
    _classCallCheck(this, Pin);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, Pin, [].concat(args));
    _defineProperty(_this2, "scroll", function () {
      _this2.props.scrollToItem(_this2.props.position)(_this2.props.sessionItemId);
    });
    return _this2;
  }
  _inherits(Pin, _Component);
  return _createClass(Pin, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Link, {
        onClick: this.scroll,
        isWithinText: false,
        display: "block"
      }, t('Question {position, number}', {
        position: this.props.position
      }));
    }
  }]);
}(Component);
_defineProperty(Pin, "propTypes", {
  scrollToItem: PropTypes.func.isRequired,
  sessionItemId: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired
});
export default Pin;